import { useState } from "react";

const StudentSearchBar = ({ handleFilter, keyword, setKeyword, width }) => {
  const [focused, setFocused] = useState(false);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        height: "42px",
        width: width || "auto",
        minWidth: "180px",
        borderRadius: "999px",
        backgroundColor: focused ? "#FFF" : "#F4F8F7",
        border: focused ? "1.5px solid #00D9C0" : "1.5px solid #E6EDEC",
        boxShadow: focused ? "0 0 0 3px rgba(0,217,192,.14)" : "none",
        transition: "all .15s",
        padding: "0 14px 0 16px",
        margin: "10px 0",
        boxSizing: "border-box",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#7A8490"
        strokeWidth="2.4"
        strokeLinecap="round"
        style={{ width: "15px", height: "15px", flexShrink: 0, cursor: "pointer" }}
        onClick={() => handleFilter()}
      >
        <circle cx="11" cy="11" r="7" />
        <line x1="16.5" y1="16.5" x2="21" y2="21" />
      </svg>
      <input
        type="text"
        placeholder="학생 이름 검색"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: "0.9rem",
          fontWeight: 600,
          color: "#0E141B",
          fontFamily: "inherit",
          marginLeft: "9px",
          minWidth: 0,
        }}
      />
    </div>
  );
};

export default StudentSearchBar;
